import styled from 'styled-components';

export const Container = styled.div`
  height: 38px;
  min-width: 200px;

  .material-icons {
    font-size: 20px;
  }

  .search-input {
    min-width: 0;
    color: ${(props) => props.theme.$dark};
  }

  .search-input::placeholder {
    color: ${(props) => props.theme.$gray600};
  }
`;
